import { createIcon } from '@chakra-ui/react';

export const FailedIcon = createIcon({
  displayName: 'FailedIcon',
  viewBox: '0 0 24 24',
  defaultProps: {
    fill: 'none',
    height: '6',
    width: '6',
  },
  path: (
    <>
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth={1.5}
      />
      <path
        d="M17.0605 8L13.0605 12L17.0605 16L16 17.0605L12 13.0605L8 17.0605L6.93945 16L10.9395 12L6.93945 8L8 6.93945L12 10.9395L16 6.93945L17.0605 8Z"
        fill="white"
      />
    </>
  ),
});
